import StatInfo from './StatInfo';

// The four-metric strip above the table on /suppliers and /payments. Extracted
// because those two rendered byte-identical copies of it and had already
// drifted once; the strip is also the part of the page users read as "the
// answer", so it is the last place that should be maintained twice.
//
// `loading` is the reason this exists as a component rather than a snippet.
// While a fetch is in flight the pages keep the PREVIOUS period's rows in
// state (deliberately — see each page's catch/empty-state reasoning), so an
// ungated strip prints last month's numbers underneath the new month's header.
// That is not a cosmetic flicker: a user switching to יוני and reading August's
// totals concludes the data is wrong, and reports a bug against the numbers.
//
// The values are replaced, never the labels, and the card keeps its height, so
// the strip stays the same size and in the same place. Blanking it instead
// collapses ~196px of layout and drags the table up under a finger already
// moving toward a row.
export default function StatCardsRow({ cards, loading = false }) {
  return (
    <div className="stats-row stats-row--quad" aria-busy={loading || undefined}>
      {cards.map(c => (
        <div className="stat-card" key={c.key}>
          <div className="stat-value">
            {loading
              ? <span className="stat-skeleton" aria-hidden="true" />
              : c.value}
          </div>
          <div className="stat-label">
            {c.label}
            {/* Suppressed while loading: the note explains how a number is
                calculated, and there is no number yet to explain. */}
            {c.info && !loading && <StatInfo label={c.label}>{c.info}</StatInfo>}
          </div>
          {/* Optional third line — .stat-card has always styled .stat-sub; the
              strip simply never offered it. Suppressed while loading for the
              same reason as the info note: it qualifies a number that is not
              on screen yet. */}
          {c.sub && !loading && <div className="stat-sub">{c.sub}</div>}
        </div>
      ))}
    </div>
  );
}
